import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext, BASE_PATH } from './NavigationContext'
import gsap from 'gsap'
import { useNavigate } from 'react-router-dom'

function Navigation() {
  const { currentSlug, setCurrentSlug } = useContext(NavigationContext)
  const [isFrontPage, setIsFrontPage] = useState(window.location.pathname === '/')
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [menuItems, setMenuItems] = useState([])
  const [siteInfo, setSiteInfo] = useState({
    name: '',
    description: ''
  })
  const navigate = useNavigate()

  useEffect(() => {
    const handlePopState = (event) => {
      const path = window.location.pathname.slice(1) || 'home'
      setCurrentSlug(path)
      setIsFrontPage(path === '' || path === 'home')
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [setCurrentSlug])

  const getHeaderClass = () => {
    return isFrontPage ? 'front-header' : 'general-header'
  }
  const handleNavClick = (e, url) => {
    e.preventDefault()
    
    // Extract the final path segment, ignoring domain and previous paths
    const targetPath = url.split('/').filter(Boolean).pop() || 'front-page'

    const artistName = document.querySelector('.artist-name')
    const tl = gsap.timeline()
    
    tl.to(artistName, {
      fontSize: targetPath === 'front-page' ? '72px' : '36px',
      duration: 0.6,
      ease: 'power2.inOut',
      onComplete: () => {
        setCurrentSlug(targetPath)
        setIsFrontPage(targetPath === 'front-page')
        navigate(`/${targetPath}`)
        setIsMenuOpen(false)
      }
    })
  }  
  const handleArtistNameClick = (e) => {
    e.preventDefault()
    const artistName = document.querySelector('.artist-name')
    const tl = gsap.timeline()
  
    tl.to(artistName, {
      fontSize: '72px',
      duration: 0.6,
      ease: 'power2.inOut',
      onComplete: () => {
        setCurrentSlug('front-page')
        setIsFrontPage(true)
        navigate('/')
      }
    })
  }

  useEffect(() => {
    fetch('/wp-json')
      .then(res => res.json())
      .then(data => setSiteInfo({
        name: data.name,
        description: data.description
      }))

    fetch('/wp-json/wp/v2/navigation')
      .then(res => res.json())
      .then(data => setMenuItems(data))
  }, [])

  return (
    <header className={getHeaderClass()}>
      <div className="subtitle">{siteInfo.description}</div>
      <div className={`artist-name ${isFrontPage ? 'front-page' : ''}`}>
        <a 
          href="/" 
          onClick={handleArtistNameClick}
        >
          {siteInfo.name}
        </a>
      </div>
      
      <button 
        className={`hamburger ${isMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={isMenuOpen ? 'active' : ''}>
        {menuItems && menuItems.map(item => (
          <a 
            key={item.ID} 
            href={item.url}
            onClick={(e) => {
              handleNavClick(e, item.url)
              setIsMenuOpen(false)
            }}
          >
            {item.title}
          </a>
        ))}
      </nav>
    </header>
  )
}

export default Navigation
